'use client';

import { useRef } from 'react';

import { Container, Stack, Typography } from '@mui/material';

import Tag from '@/types/case-study/tag';
import useMountFadeUpAnimation from '@/utils/hooks/useMountFadeUpAnimation';

import InfoItem from './InfoItem';
import styles from './IntroSection.module.scss';

interface IntroSectionProps {
  industry: Tag;
  services: Tag;
  techStack: Tag;
  kicker: string;
}

const IntroSection = ({ industry, services, techStack, kicker }: IntroSectionProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useMountFadeUpAnimation({ triggerRef: containerRef });

  return (
    <Container ref={containerRef} component="section" maxWidth="xl" className={styles.container}>
      <Stack gap={6} className={styles.infoItems}>
        {industry && <InfoItem title={industry.title} items={industry.items} variant="blue" />}
        {services && <InfoItem title={services.title} items={services.items} variant="green" />}
        {techStack && <InfoItem title={techStack.title} items={techStack.items} variant="pink" />}
      </Stack>
      <Typography
        variant="h5"
        component="h2"
        className={styles.kicker}
        sx={{
          typography: { xs: 'h5', md: 'h4' },
        }}
      >
        {kicker}
      </Typography>
    </Container>
  );
};

export default IntroSection;
